import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useLocation, useNavigate } from "react-router-dom";
import {
  addDays,
  addMonths,
  addYears,
  format as formt,
  isAfter,
  isSameMonth,
  isSameYear,
  setMonth,
  subMonths,
  subYears,
} from "date-fns";
import { getBookings } from "../../graphql/querys";
import { useMutation, useQuery } from "@apollo/client";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Select,
  MenuItem,
  TableHead,
  TableRow,
  useMediaQuery,
} from "@mui/material";
import { getBookingAnswersBased } from "../../graphql/mutations";
import { GET_EVENT as getEvent } from "../../graphql/mutations";
const AnalyticsPage = (props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const event = searchParams.get("event");
  const { loading, error, data } = useQuery(getBookings);
  const [date, setDate] = useState(new Date());
  const [barData, setBarData] = useState([]);
  const [getBasedAnswers] = useMutation(getBookingAnswersBased);
  const [lineData, setLineData] = useState([
    { name: "January", "no-shows": 5 },
    // ...remaining months
  ]);
  const [selectedBar, setSelectedBar] = useState(null);
  const [format, setFormat] = useState("year");
  const handleBarClick = (data, index) => {
    var newDate = setMonth(date, monthsRefer[data.name]);
    setDate(newDate);
    setFormat("month");
  };
  const [customers, setCustomers] = useState([]);
  const [timezones, setTimezones] = useState([]);
  var monthsRefer = {
    Jan: 0,
    Feb: 1,
    Mar: 2,
    Apr: 3,
    May: 4,
    Jun: 5,
    Jul: 6,
    Aug: 7,
    Sep: 8,
    Oct: 9,
    Nov: 10,
    Dec: 11,
  };
  const [bookedOrCompleted, setBookedOrCompleted] = useState("Booked");
  useEffect(() => {
    if (!loading) {
      setCustomers([]);
      event &&
        getEvents({ variables: { id: parseInt(event) } }).then((val) => {
          setEventDetails(val.data.getEvent);
        });
      var bookingData2;
      Promise.all(
        data.getBookings.map((val) => {
          return getEvents({ variables: { id: parseInt(val.eventId) } }).then(
            (vall) => {
              return {
                booking: val,
                event: vall.data.getEvent,
              };
            }
          );
        })
      )
        .then((results) => {
          bookingData2 = results.filter((val) => {
            const eventt = val.event;
            return (
              (format === "year"
                ? isSameYear(new Date(val.booking.time), date)
                : isSameMonth(new Date(val.booking.time), date)) &&
              (event ? val.booking.eventId == event : true) &&
              eventt?.companyId == props.currentUser.userId
            );
          });
          console.log(bookingData2);
          const bookingData =
            bookedOrCompleted == "Completed"
              ? bookingData2
                  .filter((val) => {
                    return !isAfter(new Date(val.booking.time), new Date());
                  })
                  .map((val) => val.booking)
              : bookingData2.map((val) => val.booking);
          format == "month" &&
            setSelectedBar([
              {
                name: formt(date, "MMM"),
                meetings: bookingData.filter(
                  (val) =>
                    formt(new Date(val.time), "MMMM") == formt(date, "MMMM")
                ).length,
              },
            ]);
          let updatedTimezones = [];
          bookingData.forEach((email) => {
            let existingCustomer = updatedTimezones.find(
              (customer) => customer.timezone == email.timezone
            );
            if (existingCustomer) {
              existingCustomer.meetings += 1; // Increment meeting count
            } else {
              updatedTimezones.push({
                timezone: email.timezone,
                meetings: 1,
              }); // Add new customer
            }
          });
          updatedTimezones = updatedTimezones.sort(
            (b, a) => a.meetings - b.meetings
          );
          setTimezones(updatedTimezones);
          Promise.all(
            bookingData.map((val) => {
              return getBasedAnswers({
                variables: {
                  bookingId: parseInt(val.id),
                  questionName: "Email",
                },
              }).then((res) => res.data.getBookingAnswersBased.answer);
            })
          )
            .then((results) => {
              // Create a copy of customers array to avoid direct mutation
              let updatedCustomers = [];
              results.forEach((email) => {
                let existingCustomer = updatedCustomers.find(
                  (customer) => customer.email === email
                );
                if (existingCustomer) {
                  existingCustomer.meetings += 1; // Increment meeting count
                } else {
                  updatedCustomers.push({ email: email, meetings: 1 }); // Add new customer
                }
              });
              updatedCustomers = updatedCustomers.sort(
                (b, a) => a.meetings - b.meetings
              );
              setCustomers(updatedCustomers); // Update state
            })
            .catch((error) => {
              console.log(error);
            });
          // Fetch and set data for the specified event and year when either changes
          // Replace the following dummy data with an actual data fetching
          setBarData(
            [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ].map((name) => {
              return {
                name: name.slice(0, 3),
                meetings: bookingData.filter(
                  (val) => formt(new Date(val.time), "MMMM") == name
                ).length,
              };
            })
            // ...remaining months
          );
          setLineData([
            { name: "January", "no-shows": 10 },
            // ...remaining months
          ]);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [event, date, loading, format, bookedOrCompleted]);
  const isXSScreen = useMediaQuery("(max-width:760px)");
  const [eventDetails, setEventDetails] = useState([]);
  const [getEvents] = useMutation(getEvent);
  const navigate = useNavigate();
  const [eventSelected, setEventSelected] = useState(event);
  if (loading) return "Loading";
  return (
    <Box
      sx={{
        height: "100%",
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <div className="flex align">
        <Typography variant="h4" gutterBottom sx={{ p: 2 }}>
          Analytics {event ? "for event " + eventDetails?.title : ""}
        </Typography>
        <Select
          value={eventSelected ? eventSelected : "None"}
          style={{ maxHeight: "45px", minWidth: "150px" }}
        >
          {props.data.map((val) => (
            <MenuItem
              onClick={() => {
                navigate("/app/analytics?event=" + val.id);
              }}
              value={val.id}
            >
              <div className="flex" style={{ gap: "15px", width: "100%" }}>
                <div
                  className="circle"
                  style={{ backgroundColor: val.color }}
                ></div>
                <Typography className="font">{val.name}</Typography>
              </div>
            </MenuItem>
          ))}
          <MenuItem value="None" onClick={() => navigate("/app/analytics")}>
            <Typography className="font">All events</Typography>
          </MenuItem>
        </Select>
      </div>
      <div className="flex" style={{ gap: "10px" }}>
        <ChevronLeft
          disabled
          className={`prev-btn `}
          onClick={() => {
            setDate(format == "year" ? subYears(date, 1) : subMonths(date, 1));
          }}
        />
        <Typography variant="h5">
          {format == "year"
            ? date.getFullYear()
            : formt(new Date(date), "MMMM yyyy")}
        </Typography>
        <ChevronRight
          className={`next-btn `}
          onClick={() => {
            setDate(format == "year" ? addYears(date, 1) : addMonths(date, 1));
          }}
        />
        {format == "month" && (
          <Button onClick={() => setFormat("year")}>Yearly View</Button>
        )}
      </div>
      <div
        className={"flex " + (isXSScreen && "column")}
        style={{ gap: "30px", height: "430px" }}
      >
        <Card raised className="flex column" style={{ flex: 1 }} sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Number of Meetings{" "}
            <Select value={bookedOrCompleted}>
              <MenuItem
                onClick={() => setBookedOrCompleted("Completed")}
                value="Completed"
              >
                Completed
              </MenuItem>
              <MenuItem
                onClick={() => setBookedOrCompleted("Booked")}
                value="Booked"
              >
                Booked
              </MenuItem>
            </Select>
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={format == "month" ? selectedBar : barData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar
                dataKey="meetings"
                fill="#8884d8"
                onClick={handleBarClick}
                opacity={(data) =>
                  selectedBar && data.name !== selectedBar ? 0 : 1
                }
              />
            </BarChart>
          </ResponsiveContainer>
        </Card>
        <Card raised className="flex" sx={{ p: 3 }}>
          <CardContent className="width100">
            <Typography variant="h6" gutterBottom>
              Timezones
            </Typography>
            <TableContainer className="width100">
              <Table className="width100">
                <TableHead className="width100">
                  <TableRow>
                    <TableCell>Timezone</TableCell>
                    <TableCell>Meetings</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="width100">
                  {timezones.map((customer) => (
                    <TableRow key={customer.timezone}>
                      <TableCell component="th" scope="row">
                        {customer.timezone}
                      </TableCell>
                      <TableCell>{customer.meetings}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
        <Card raised className="flex" sx={{ p: 3 }}>
  <CardContent className="width100">
    <Typography variant="h6" gutterBottom>
      Top Customers
    </Typography>
    <TableContainer style={{ maxHeight: 400 }}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell>Email</TableCell>
            <TableCell>Meetings</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {customers.map((customer) => (
            <TableRow key={customer.email}>
              <TableCell component="th" scope="row">
                {customer.email}
              </TableCell>
              <TableCell>{customer.meetings}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </CardContent>
</Card>
      </div>
      {/* Add more cards for other analytics */}
    </Box>
  );
};

export default AnalyticsPage;
